module.exports = __webpack_public_path__ + "img/chalk_7.1ddfe4a7.png";